module.exports = __webpack_public_path__ + "img/empty.ac0225e9.svg";